import PropTypes from 'prop-types'
import React from 'react'

import {
    Box,
    Divider,
    Flex,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {styleConfigChakraKeys} from '../../constants'
import Link from '../link'

const FooterMeta = ({variant, copyright, bottomActions, socialMediaIcons}) => {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.footer, {variant})

    return (
        <Flex
            {...styles.footerMeta}
            flexFlow="column"
            id="footer-meta"
            width="100%"
            p={{base: '24px', xl: '24px    40px'}}
            gap={{base: '24px', lg: 'unset'}}
            alignItems={{base: 'flex-start', lg: 'center'}}
        >
            <Flex
                flexFlow={{base: 'column-reverse', lg: 'column'}}
                gap={{base: '24px', lg: 'unset'}}
            >
                <Text {...styles.copyright}>{copyright}</Text>
                <Divider {...styles.divider} display={{lg: 'none'}} />
            </Flex>

            <Flex
                justifyContent={{base: 'flex-start', lg: 'center'}}
                alignItems={{base: 'flex-start', lg: 'center'}}
                gap={{base: '8px', lg: '32px'}}
                flexFlow={{base: 'column', lg: 'row'}}
            >
                {bottomActions?.map((item, index) => (
                    <Link
                        textWrapMode={{base: 'nowrap', lg: 'wrap'}}
                        key={`${item?.contentfulTitle}-${index}`}
                        {...item}
                        type="tertiary"
                        {...styles.footerMetaLink}
                    />
                ))}
            </Flex>

            <Box {...styles.socialIcons}>
                {socialMediaIcons?.map((item, index) => (
                    <Link
                        {...item}
                        type="tertiary"
                        key={`${item?.contentfulTitle}-${index}`}
                        iconStyles={{width: '24px', height: '24px'}}
                    />
                ))}
            </Box>
        </Flex>
    )
}

FooterMeta.propTypes = {
    copyright: PropTypes.string,
    socialMediaIcons: PropTypes.arrayOf(
        PropTypes.shape({
            iconName: PropTypes.string,
            type: PropTypes.string,
            text: PropTypes.string,
            url: PropTypes.string,
            isExternal: PropTypes.bool
        })
    ),
    bottomActions: PropTypes.arrayOf(
        PropTypes.shape({
            iconName: PropTypes.string,
            type: PropTypes.string,
            text: PropTypes.string,
            url: PropTypes.string,
            isExternal: PropTypes.bool
        })
    ),
    variant: PropTypes.string
}

export default FooterMeta
